import { HStack, Link, Skeleton, Text } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import NextLink from 'next/link';

import { useLecturePageQueryParams } from '@/components/ui/features/lecture/hooks';
import { LabelText } from '@/components/ui/features/lecture/LectureInfo/LectureInfo.elements';
import { queryThinLectureWithTagAndEvent } from '@/fetchers/thinLectures';
import { useResource } from '@/lib/datx-jsonapi-react';
import { countryQueryOptions } from '@/queries/upgrade/countries';
import { dateToString } from '@/utils/date';
import { getEventHref } from '@/utils/getEventHref';

const lectureLiveMark = 'Live on Underline';

const Dot = () => <Text fontWeight="bold">•</Text>;

export const LectureInfoSubtitle = () => {
  const { id: lectureId } = useLecturePageQueryParams();
  const { data: lecture } = useResource(queryThinLectureWithTagAndEvent(lectureId));
  const { data: country } = useQuery(countryQueryOptions(lecture?.event?.countryId));

  const labelDate = `${dateToString(lecture?.heldAt, 'MMMM dd, yyyy')}`;
  const labelLocation = `${lecture?.event?.city ? `${lecture?.event?.city}, ` : ''}${country?.name || ''}`;

  if (!lecture) {
    return <Skeleton height="1.2rem" width="150px" />;
  }

  return (
    <HStack>
      {!lecture?.event?.visible && <LabelText>{lecture?.event?.name}</LabelText>}
      {lecture?.event?.visible && (
        <NextLink href={getEventHref(lecture?.event)} passHref legacyBehavior>
          <Link>
            <LabelText>{lecture?.event?.name}</LabelText>
          </Link>
        </NextLink>
      )}
      <Dot />
      <Text>{labelDate}</Text>
      <Dot />
      <Text>{lecture?.event?.city === lectureLiveMark ? lectureLiveMark : labelLocation}</Text>
    </HStack>
  );
};
